export type LoginMethod = "google" | "email";

const KEY = "nablow-last-login";
const EMAIL_KEY = "nablow-last-email";

export const readLastLogin = (): LoginMethod | null => {
  try {
    const value = window.localStorage.getItem(KEY);
    return value === "google" || value === "email" ? value : null;
  } catch {
    return null;
  }
};

export const readLastEmail = (): string => {
  try {
    return window.localStorage.getItem(EMAIL_KEY) ?? "";
  } catch {
    return "";
  }
};

export const rememberLogin = (method: LoginMethod, email?: string): void => {
  try {
    window.localStorage.setItem(KEY, method);
    if (email) window.localStorage.setItem(EMAIL_KEY, email);
  } catch {
    return;
  }
};
